import React from "react";

export default function CartSpecialOfferDisplay({offer, handleRemoveCoupon}) {

  return <div className="p-2 text-left text-xs">
    <div className="lg:w-1/2">
      <div className="">
        <span className="fas fa-ticket mr-2 text-brand-dark  align-middle" />
        <span className="align-middle">Coupon applied to your cart:</span>
      </div>
      <div className="py-2">
        <strong>{offer.name}</strong>
        <div>{offer.description}</div>
      </div>

      <div className="py-1">
        <a className="cursor-pointer underline text-pencil hover:text-black"
          onClick={handleRemoveCoupon}>
          <span className="fa fa-times mx-1"/>
          remove coupon
        </a>
      </div>
    </div>

  </div>
}
